import getRouteTransferType from "@Route/features/transportType/functions/getRouteTransferType";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";

export const isPrivateMinivanRoute = (routeTransferType: RouteTransferTypeKeys): boolean => (
    getRouteTransferType(routeTransferType) === 'privateMinivan'
)